import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'etxe-property-draft-card-skeleton',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './property-draft-card-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDraftCardSkeletonComponent {}
